import { styled, Box, Typography } from '@mui/material';

export const ProvidersDetailsBoxStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '25px 40px 25px 40px',
  '@media (max-width: 743px)': {
    display: 'block',
    justifyContent: 'center',
    textAlign: 'center',
    height: 'auto',
  },
});

export const ProvidersCardHeaderStyled = styled(Box)({
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '4px',
});

export const ProvidersPremiumBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',

  '@media (max-width: 743px)': {
    display: 'block',
    justifyContent: 'center',
    marginBottom: '20px',
  },
});

export const ProvidersPremiumTextStyled = styled(Typography)({
  fontSize: 33,
  fontWeight: 400,
  '@media (max-width: 743px)': {
    textAlign: 'center',
    fontSize: 33,
    fontWeight: 400,
  },
});

export const AddYourProvidersCardStyled = styled('div')({
  paddingBottom: '20px !important',
});
